import { Copy, Pencil, ThumbsDown, ThumbsUp } from "lucide-react";
import "./AgentChatResponseToolbar.css";

import { handleCopyText } from "../uiHelpers";
import { toastSuccess } from "../../config";
import toast from "react-hot-toast";
import { AgentFinalResponseMessage } from "./types";

type AgentChatResponseToolbarProps = {
  message: AgentFinalResponseMessage;
};

export const AgentChatResponseToolbar = ({
  message,
}: AgentChatResponseToolbarProps) => {
  const handleCopy = async () => {
    console.log("Copy");
    handleCopyText(message.finalResponse.answer);
  };

  return (
    <div className="agent-chat-response-toolbar">
      <div className="agent-chat-response-toolbar-item" onClick={handleCopy}>
        <Copy size={16} />
      </div>
      {/* <div
        className="agent-chat-response-toolbar-item"
        onClick={() => toast("Thanks for the feedback!", toastSuccess)}>
        <ThumbsUp size={16} />
      </div>
      <div
        className="agent-chat-response-toolbar-item"
        onClick={() => toast("Thanks for the feedback!", toastSuccess)}>
        <ThumbsDown size={16} />
      </div>
      <div className="agent-chat-response-toolbar-item">
        <Pencil size={16} />
      </div> */}
    </div>
  );
};
